import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const DestinationIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M8 5V6.66667M8 6.66667H18L16.3333 10L18 13.3333H8M8 6.66667V13.3333M8 20V13.3333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props || $[2] !== ref) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}</svg>;
    $[1] = props;
    $[2] = ref;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
});
export default DestinationIcon;